import { useState } from "@hookstate/core";
import { state } from "./state";

export const useWithdrawFundsModal = () => {
  return useState(state.withdrawFundsModal);
};
